// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1b2b0253ce6aa2a02439","293":"11a8934a82b252f32f2e","518":"ce75fe5590dc66bc65a1","779":"9b27a3dfa82a423fa2cd"}[chunkId] + ".js";
};